// extracted by mini-css-extract-plugin
module.exports = {"DeleteAccountContainer":"DeleteAccount_DeleteAccountContainer__37MVM","Heading":"DeleteAccount_Heading__3AJxf","WarningText":"DeleteAccount_WarningText__1SO78"};